export const customerNo = localStorage.getItem('customerNo')
export const role = localStorage.getItem('role')

export const DATE_DDMMYYYY = 'DD-MM-YYYY';
export const DATE_ddMMYYYY = 'dd-MM-yyyy';
export const DATE_YYYYMMDD = 'YYYY-MM-DD';
export const DATE_YYYYMM = 'YYYY-MM';
export const MORE_THAN_3_CHRACTERS = 'Must be more than 3 letters';

export const DATE_FORMATS = {
    DATE_YYYYMM,
    DATE_YYYYMMDD,
    DATE_ddMMYYYY,
    DATE_DDMMYYYY,
    DATE_YYYYMMDDHHmmss : 'YYYY-MM-DD HH:mm:ss'
}

export const mastersExportDisabled = ()=>{
    switch(customerNo.toString()){
        case '1545':
         return ["ADMINISTRATOR", "ELIXIR"].includes(role?.toString().toUpperCase()) ? false : true;
        default : 
         return false;
    }
}

export const ERROR_MESSAGES = {
    INVALID_VEHICLE_NO : 'Invalid Vehicle Number',
    REQUIRED : 'Required',
    INVALID_FORMAT : "Invalid Format",
    LESS_THAN_CHARECTERS : (no)=> `Must be less than ${no} characters`,
    LESS_THAN : (no)=> `Must be less than ${no}`,
    MUST_BE_POSITIVE_NO : 'Must be a Valid Positive Number',
    INS_VALUE : 'Insurance Value must be whole number',
    INS_PREMIUM : 'Insurance Premium must be whole number',
    INVALID_FIELD :(field)=> `Invalid ${field}`
}

export const BATTERY_JOBCARD_ACTIVITY = {
    ADD : 4,
    REMOVE : 5,
    REPLACE: 6 ,
}

export const FEATURES = {
    mastersExportDisabled
}